import { getBackgroundColor, viewFileByUrl } from "../../../utils/functions";
import FOTO_DEFAULT from "../../../assets/user_icon.png";
import { useState, useEffect } from "react";

export default function CredencialButtonV2({ user }) {
  const [dataCarne, setDataCarne] = useState(null);

  useEffect(() => {
    fetchDataCarne();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ------- datos carne -------
  const fetchDataCarne = async () => {
    const participanteData = {
      idparticipante: user._id,
      correlativo: user.correlativo,
      nombre: user.nombre,
      apellido: user.apellido,
      nombrecompleto: `${user.apellido}, ${user.nombre}`,
      nrodocumento: user.nrodocumento,
      tipoparticipacion: user.tipoparticipacion,
      tipoparticipante: user.tipoparticipante,
      color: getBackgroundColor[user.color] || "CIAN",
      fotografia: viewFileByUrl("foto_rostro", user.nrodocumento + "-FOT.jpg") || FOTO_DEFAULT,
      lugarexamen: user.lugarexamen
    };

    const tmp = JSON.stringify(participanteData);
    setDataCarne(encodeURIComponent(tmp));
  };

  return (
    <iframe
      width="200"
      height="50"
      src={`${process.env.REACT_APP_BASE_FOTO_PATH}/doblecolor?token=${dataCarne}`}
      title="Descarga Credencial"
    ></iframe>
  );
}
